<div>
  <div class="flex justify-end">
    <desy-button
      (clickEvent)="selectProtocol()"
      [classes]="'ml-sm'">
      Seleccionar
    </desy-button>
  </div>
  <div class="my-4 flex justify-between items-center">
    <h2 class="c-h2">{{ protocol.protocolName }}</h2>
  </div>
  <div class="my-4">
    <h3 class="c-h3"><strong>Resumen</strong></h3>
    <p class="c-paragraph-base text-neutral-dark">
      {{ protocol.protocolDetails | uppercaseFirstLetterFirstWord }}
    </p>
  </div>
  <div class="my-4">
    <app-collapsible
      [title]="'Datos disponibles para la consulta'"
      [open]="false"
      [items]="protocol.protocolData" />
  </div>
  <div class="my-4">
    <h3 class="c-h3"><strong>Organismo responsable</strong></h3>
    <p class="c-paragraph-base text-neutral-dark">{{ protocol.responsibleOrganism | uppercaseAll }}</p>
  </div>
  <div class="my-4">
    <h3 class="c-h3"><strong>Departamento</strong></h3>
    <p class="c-paragraph-base text-neutral-dark">{{ protocol.protocolDepartment | uppercaseAll }}</p>
  </div>
  <div class="my-4">
    <h3 class="c-h3"><strong>Condiciones</strong></h3>
    <p class="c-paragraph-base text-neutral-dark">
      {{
        (protocol?.protocolConditions ? protocol.protocolConditions : 'No hay condiciones especiales en la adhesión.')
          | uppercaseFirstLetterFirstWord
      }}
    </p>
  </div>
</div>
